export const FETCH_ACTIVITY_LOGS_SUCCESS = 'FETCH_ACTIVITY_LOGS_SUCCESS';
export const FETCH_ACTIVITY_LOGS_REQUEST = 'FETCH_ACTIVITY_LOGS_REQUEST';
export const FETCH_ACTIVITY_LOGS_FAILURE = 'FETCH_ACTIVITY_LOGS_FAILURE';
export const FETCH_ACTIVITY_LOGS_REST = 'FETCH_ACTIVITY_LOGS_REST';
export const fetchActivityLogsSuccess = (payload) => ({
    type: FETCH_ACTIVITY_LOGS_SUCCESS,
    payload,
});
export const fetchActivityLogsRequest = (payload) => ({
    type: FETCH_ACTIVITY_LOGS_REQUEST,
    payload,
});
export const fetchActivityLogsFailure = (payload) => ({
    type: FETCH_ACTIVITY_LOGS_FAILURE,
    payload,
});
export const fetchActivityLogsReset = () => ({
    type: FETCH_ACTIVITY_LOGS_REST,
});
